<template>
    <modal class="modal" :show="modal_show" body-classes="card-body" modal-classes="modal-dialog-centered modal-lg"
        footer-classes="card-footer" header-classes="card-header" v-on:close="onClose()">

        <template v-slot:header>
            <h2>{{ $t(this.$route.name + '.moduleStatusModalTitle') }}</h2>
        </template>
        <div id="card-body">
            <!-- Module name -->
            <div class="row">
                <h4>{{ $t($route.name + '.moduleStatusModuleName') + ": " + module_data.name }}</h4>
            </div>
            <div class="row">
                <div class="col">
                    <span :style="getStatusColor()">
                        {{ $t($route.name + '.moduleStatusStatus') }}: {{
                            $t($route.name +
                                '.moduleStatus' + module_status)
                        }}</span>
                </div>
                <div class="col">
                    <base-button type="primary" class="btn btn-block btn-primary" style="width:100%"
                        v-on:click="onUpdateButton()">
                        {{ $t(this.$route.name + '.moduleStatusUpdateButton') }}
                    </base-button>
                </div>
            </div>
            <!-- End of module name -->

            <div v-if="data_ready === 'ready'">
                <!-- Last measure date-->
                <div class="row">
                    <div class="col">
                        {{ $t($route.name + '.moduleStatusLastMeasureDate') }}:
                    </div>
                    <div class="col">
                        {{ formattedDatetime(data.raw.received_datetime) }}
                    </div>
                </div>
                <!-- Data -->
                <div class="row">
                    <div class="table-responsive">
                        <base-table thead-classes="thead-light" :data="parseProcessedData()">
                            <template v-slot:columns>
                                <th>{{ $t($route.name + '.moduleStatusMeasureNameHeader') }}</th>
                                <th>{{ $t($route.name + '.moduleStatusProcessedHeader') }}</th>
                                <th>{{ $t($route.name + '.moduleStatusRawHeader') }}</th>
                            </template>
                            <template v-slot:default="row">
                                <th scope="row">
                                    {{ $t($route.name + '.moduleStatus_' + row.item.measure) }}
                                </th>
                                <td>
                                    {{ row.item.value }} {{ row.item.unit }}
                                </td>
                                <td>
                                    {{ row.item.raw }}
                                </td>
                            </template>
                        </base-table>
                    </div>
                </div>
                <hr>
                <!-- Errors -->
                <div class="row" v-if="data.processed.errors">
                    <div class="col">
                        <div class="row">
                            <h3>{{ $t($route.name + '.moduleStatusErrorHeader') }}:</h3>
                        </div>
                        <div class="row">
                            <div class="table-responsive">
                                <base-table thead-classes="thead-light" :data="data.processed.errors">
                                    <template v-slot:columns>
                                        <th>{{ $t($route.name + '.moduleStatusErrorCode') }}</th>
                                        <th>{{ $t($route.name + '.moduleStatusErrorComponent') }}</th>
                                        <th>{{ $t($route.name + '.moduleStatusErrorTimes') }}</th>
                                    </template>
                                    <template v-slot:default="row">
                                        <td scope="row">
                                            {{ row.item.code }}
                                        </td>
                                        <td>
                                            {{ row.item.component }}
                                        </td>
                                        <td>
                                            {{ row.item.times }}
                                        </td>
                                    </template>
                                </base-table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div v-else-if="data_ready === 'error'">
                {{ error_msg }}
            </div>
            <div v-else>
                {{ $t($route.name + '.moduleStatusNoErrors') }}
            </div>
        </div>


        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <base-button type="primary" class="btn btn-block btn-warning" v-on:click="onClose()">
                        {{ $t(this.$route.name + '.cancelButton') }}
                    </base-button>
                </div>
            </div>
        </template>

    </modal>
</template>
<script>
import DataService from '@/services/data.service'

import useVuelidate from '@vuelidate/core'

const statusColors = {
    'Good': 'color: Green',
    'Warning': 'color: Orange',
    'Error': 'color: Red'
}

export default {
    name: "module-status",
    setup() {
        return { v$: useVuelidate() }
    },
    props: {
        modal_show: {
            type: Boolean,
            default: false,
        },
        module_data: null,
    },
    data() {
        return {
            show: {
                type: Boolean,
                default: false,
            },
            inner_data: null,
            data_ready: 'loading',
            data: null,
            error_msg: '',
        };
    },
    mounted() {
        this.onShow();
    },
    methods: {
        onShow() {
            this.inner_data = JSON.parse(JSON.stringify(this.module_data));
            this.onUpdateButton();
        },

        onClose: function () {
            this.$emit('update:modal_show', false);

        },
        getStatusColor() {
            return statusColors[this.module_status];
        },

        onUpdateButton: function () {

            DataService.getLatestDataByModuleId(this.module_data.id).then(
                (data) => {
                    this.data = data;
                    this.checkModuleErrors();
                    this.data_ready = 'ready';
                },
                error => {
                    this.data_ready = 'error';
                    this.error_msg = error;
                    this.module_status = 'Error';
                }
            )
        },
        getDataHeaders() {
            const headers = []
            for (let data of this.data.processed.sensors_data) {
                headers.push({ name: data['measure'], unit: data['unit'] })
            }
            return headers
        },
        parseRawData() {

            const raw = this.data.raw.data.split(';');

            return raw[3].split(',');
        },
        parseProcessedData() {

            const raw = this.parseRawData();
            const processed = this.data.processed.sensors_data;
            for (let i = 0; i < processed.length; i++) {
                processed[i].raw = raw[i];
            }
            return processed;
        },

        checkModuleErrors() {
            if (this.data.raw != null) {
                if (!this.checkDateIsToday()) {
                    this.module_status = 'Error';
                } else if (this.data.processed.errors == null) {
                    this.module_status = 'Good';
                } else {
                    this.module_status = 'Warning';
                }
            } else {
                this.module_status = 'Error';
            }
        },
        checkDateIsToday() {
            const today = new Date();
            const dataDate = new Date(this.data.raw.received_datetime);
            if (dataDate.getFullYear() != today.getFullYear()) {
                return false;
            }
            if (dataDate.getMonth() != today.getMonth()) {
                return false;
            }
            if (today.getDay() != dataDate.getDay()) {
                return false;
            }
            return true;
        },
        formattedDatetime(datetime) {
            const dt = datetime.split('T');
            return dt[0] + ' || ' + dt[1].split('.')[0]
        }

    },
    watch: {
        module_data: function () {
            if (this.module_data != null) {
                this.onShow();
            }
        }
    }
};
</script>
<style>
.modal {
    overflow: auto !important;
}
</style>
